import moment from 'moment';
import 'moment/locale/fi';
import 'moment/locale/sv';

moment.locale('en');
